import { render, staticRenderFns } from "./FormFileCaptureImage.vue?vue&type=template&id=74f9a397&scoped=true&"
import script from "./FormFileCaptureImage.vue?vue&type=script&lang=js&"
export * from "./FormFileCaptureImage.vue?vue&type=script&lang=js&"
import style0 from "./FormFileCaptureImage.vue?vue&type=style&index=0&id=74f9a397&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f9a397",
  null
  
)

export default component.exports